import Appsignal from '@appsignal/javascript';
import {plugin as breadcrumbs} from '@appsignal/plugin-breadcrumbs-network';
import {plugin as pathDecorator} from '@appsignal/plugin-path-decorator';
import {plugin as windowEvents} from '@appsignal/plugin-window-events';
import {getTags} from '~library/utils/evite/tagging';

export const appsignal = new Appsignal({
  key: window.app_signal_api_key,
  revision: process.env.VERSION,
});
appsignal.use(windowEvents()); // should log all uncaught errors in AppSignal
appsignal.use(pathDecorator());
appsignal.use(breadcrumbs());

// these keys come from common_base.html
const WINDOW_VARIABLE_KEYS = [
  'user_id',
  'isAuthenticated',
  'subscriptionPlanName',
  'isProUser',
  'isPartyPassUser',
  'isGreetingCardSubUser',
  'evite_version',
] as const;

appsignal.addDecorator((span) => {
  const tags = WINDOW_VARIABLE_KEYS.reduce((acc: Record<string, string>, key: string) => {
    // biome-ignore lint/suspicious/noExplicitAny: bypass the type checking, as we know the keys exist and are strings
    const value = key in window ? (window as any)[key] : 'NOT_SET';
    acc[key] = `${key}_${value}`;
    return acc;
  }, {});
  const globalTags = getTags();
  Object.assign(tags, globalTags);
  tags.url = `url_${window.location.href}`;
  tags.baseUrl = `baseUrl_${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  span.setNamespace('frontend');
  span.setAction('EviteErrorHandler');
  return span.setTags(tags);
});

window.document.body.addEventListener('pointermove', () => {
  document.body.classList.add('using-mouse');
});

window.document.body.addEventListener('keydown', () => {
  document.body.classList.remove('using-mouse');
});
